import React from 'react';
import { usePageTitle } from '../lib/usePageTitle';
import PageWithNavbar from '../components/PageWithNavbar';

export default function TermsOfServicePage() {
  usePageTitle('Terms of Service');

  return (
    <PageWithNavbar>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', lineHeight: 1.6 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 32, color: '#2563eb' }}>
          Terms of Service
        </h1>
        
        <p style={{ marginBottom: 24, color: '#666' }}>
          <strong>Last updated:</strong> {new Date().toLocaleDateString()}
        </p>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Acceptance of Terms
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            By accessing and using this service provided by T.A. Trussell Management, LLC, you accept and agree to be bound by the terms 
            and provision of this agreement. If you do not agree to abide by the above, please do not 
            use this service.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Description of Service
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            T.A. Trussell Management, LLC provides a family management platform that includes:
          </p>
          <ul style={{ marginLeft: 20, marginBottom: 16, color: '#555' }}>
            <li style={{ marginBottom: 8 }}>AI-powered gift recommendations for family members</li>
            <li style={{ marginBottom: 8 }}>Occasion reminders and calendar management</li>
            <li style={{ marginBottom: 8 }}>Address and preference management for family members</li>
            <li style={{ marginBottom: 8 }}>Integration with third-party services for product recommendations</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            User Accounts and Responsibilities
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            You are responsible for:
          </p>
          <ul style={{ marginLeft: 20, marginBottom: 16, color: '#555' }}>
            <li style={{ marginBottom: 8 }}>Maintaining the confidentiality of your account credentials</li>
            <li style={{ marginBottom: 8 }}>All activities that occur under your account</li>
            <li style={{ marginBottom: 8 }}>Providing accurate and up-to-date information</li>
            <li style={{ marginBottom: 8 }}>Notifying us immediately of any unauthorized use of your account</li>
            <li style={{ marginBottom: 8 }}>Ensuring you have permission to add other family members' information</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Acceptable Use
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            You agree not to use the service to:
          </p>
          <ul style={{ marginLeft: 20, marginBottom: 16, color: '#555' }}>
            <li style={{ marginBottom: 8 }}>Upload malicious code or attempt to compromise system security</li>
            <li style={{ marginBottom: 8 }}>Interfere with or disrupt the service or servers</li>
            <li style={{ marginBottom: 8 }}>Attempt to gain unauthorized access to other user accounts</li>
            <li style={{ marginBottom: 8 }}>Use the service for any illegal or harmful purposes</li>
            <li style={{ marginBottom: 8 }}>Add information about individuals without their consent</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            AI-Generated Content
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            Our gift recommendations are generated using artificial intelligence. While we strive for 
            accuracy and relevance, we cannot guarantee that all recommendations will be appropriate 
            or available. You should always use your own judgment when making purchase decisions.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Third-Party Services
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            Our platform integrates with third-party services (such as product retailers and AI providers). 
            We are not responsible for the availability, accuracy, or policies of these third-party services. 
            Your interactions with third-party services are governed by their respective terms and policies.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Intellectual Property
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            The service and its original content, features, and functionality are owned by T.A. Trussell Management, LLC 
            and are protected by copyright, trademark, and other intellectual property laws. You retain 
            ownership of any personal information and content you provide to the service.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Data and Privacy
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            Your privacy is important to us. Please review our Privacy Policy, which also governs 
            your use of the service, to understand our practices regarding the collection and use 
            of your information.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Service Availability
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            We strive to maintain high availability but cannot guarantee uninterrupted service. 
            The service may be temporarily unavailable due to maintenance, updates, or technical issues. 
            We reserve the right to modify or discontinue the service with reasonable notice.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Limitation of Liability
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            To the maximum extent permitted by law, T.A. Trussell Management, LLC shall not be liable for any 
            indirect, incidental, special, consequential, or punitive damages, including but not 
            limited to loss of profits, data, or other intangible losses resulting from your use 
            of the service.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Account Termination
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            You may terminate your account at any time by contacting us or using account settings. 
            We may terminate or suspend your account immediately if you violate these terms. 
            Upon termination, your right to use the service will cease, but data retention may 
            continue as outlined in our Privacy Policy.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Changes to Terms
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            We reserve the right to modify these terms at any time. Material changes will be 
            communicated through the service or via email. Your continued use of the service 
            after changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Governing Law
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            These terms shall be governed by and construed in accordance with the laws of the 
            jurisdiction in which T.A. Trussell Management, LLC operates, without regard to conflict of law principles.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Contact Information
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            If you have any questions about these Terms of Service, please contact us through 
            your account settings or reach out to our support team.
          </p>
        </section>
      </div>
    </PageWithNavbar>
  );
}